import axios from 'axios';

import { getApiEndPoint } from '../helpers/apibase';
import { mapServerError } from './utils/serverErrorMapper';

type UserPermissionsResource = {
  resourceType: string;
  resourceId: string;
  permissions: string[];
};

export type GetOwnPermissionsResponse = {
  resources: Record<string, UserPermissionsResource>;
};

const userPermissionsApi = axios.create({
  baseURL: getApiEndPoint(),
  withCredentials: true,
});

export const getOwnPermissionsQueryKey = 'getOwnPermissions';

export async function getOwnPermissions(orgId: string): Promise<GetOwnPermissionsResponse> {
  try {
    const response = await userPermissionsApi.get<GetOwnPermissionsResponse>(
      `/auth/orgs/${encodeURIComponent(orgId)}/user/permissions`
    );
    return response.data;
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export function flattenPermissions(response: GetOwnPermissionsResponse): string[] {
  return Array.from(
    new Set(Object.values(response.resources ?? {}).flatMap((r) => r.permissions ?? []))
  );
}

const userPermissionsService = {
  getOwnPermissions,
  getOwnPermissionsQueryKey,
  flattenPermissions,
};

export default userPermissionsService;
